import { twMerge } from 'tailwind-merge';

interface SpinnerProps {
	size?: 'small' | 'medium' | 'large';
	className?: string;
}

export const Spinner = ({ size = 'medium', className }: SpinnerProps) => {
	const sizeClasses = {
		small: 'w-3 h-3',
		medium: 'w-5 h-5',
		large: 'w-7 h-7',
	};

	return (
		<div
			className={twMerge(
				'animate-spin rounded-full border-2 border-current border-t-transparent',
				sizeClasses[size],
				className,
			)}
		/>
	);
};
